<template>
  <div
      :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive }
    ]"
      class="wrapper">
    <notifications></notifications>
    <side-bar
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor">
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item :link="{ name: 'Dashboard', icon: 'dashboard', path: '/dashboard' }"></sidebar-item>
        <sidebar-item :link="{ name: 'TodayDashboard', icon: 'dashboard', path: '/today' }"></sidebar-item>
        <sidebar-item v-if="!isStaff" :link="{ name: 'Company Detail', icon: 'file_open', path: '/dashboard' }">
        </sidebar-item>
        <sidebar-item v-if="roles.length" :link="{ name: 'Supervisor', icon: 'follow_the_signs' }">
          <sidebar-item v-if="can('list-labourer-schedule')"
                        :link="{ name: 'CheckIn Appr', path: '/vendors/labourer/schedule/approve' }"></sidebar-item>
          <sidebar-item v-if="can('list-labourer-schedule')"
                        :link="{ name: 'Supervisor New', path: '/vendors/supervisor/checkin/checkout' }"></sidebar-item>

          <sidebar-item v-if="can('list-labourer-schedule')"
                        :link="{ name: 'Labourer Shift Report', path: '/vendors/labourer-shift-report' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="roles.length" :link="{ name: 'Muongozo', icon: 'follow_the_signs' }">
          <sidebar-item v-if="can('list-guidance')"
                        :link="{ name: 'Guidance', path: '/settings/list-guidances' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="roles.length" :link="{ name: 'Finance', icon: 'price_change' }">
          <sidebar-item v-if="can('list-tariff')"
                        :link="{ name: 'Tariff', path: '/employer/employer/list-tariffs'}"/>
          <sidebar-item v-if="can('list-invoice')"
                        :link="{ name: 'Utilization Sheet', path: '/finance/list-invoices' }"/>
          <!--          <sidebar-item v-if="can('list-invoice-item')"-->
          <!--                        :link="{ name: 'Utilization Sheet Items', path: '/finance/list-invoice-items' }"/>-->
          <sidebar-item v-if="can('list-voucher')"
                        :link="{ name: 'Utilization Sheet Summary', path: '/finance/voucher/lists' }"/>
        </sidebar-item>
        <sidebar-item v-if="roles.length" :link="{ name: 'Labourer Finance', icon: 'price_change' }">
          <sidebar-item v-if="can('list-employee')"
                        :link="{ name: 'Ready For Payment',
                        path: '/labourer/payment/ready' }"/>
          <sidebar-item v-if="can('list-employee')"
                        :link="{ name: 'Labourer Payments',
                        path: '/labourer/payment/list' }"/>
        </sidebar-item>
        <sidebar-item v-if="can('list-employee')"
                      :link="{  name: 'Employees', path: '/vendors/list-employees', icon: 'supervisor_account'}"/>

        <sidebar-item v-if="roles.length" :link="{ name: 'Labourers', icon: 'wc' }">
          <sidebar-item v-if="can('list-labourer')"
                        :link="{ name: 'Labourers Readiness', path: '/vendors/labourers/readiness',icon: 'assignment_turned_in'}"/>
          <sidebar-item v-if="can('list-labourer')"
                        :link="{ name: 'Labourers List', path: '/vendors/list-labourers',icon: 'wc'}"/>
          <sidebar-item v-if="can('list-labourer-attendance')"
                        :link="{ name: 'Labourer Attendances', path: '/vendors/list-labourer-attendances',icon: 'rule'}"/>
          <sidebar-item v-if="can('list-activity-labourer-workplace')"
                        :link="{ name: 'Long Take on', path: '/settings/activity/labourer/workplace',icon: 'favorite'}"/>
          <sidebar-item v-if="can('list-labourer-schedule')"
                        :link="{ name: 'Takeon List', path: '/vendors/list-labourer-schedules',icon: 'playlist_add_check'}"/>
          <sidebar-item v-if="can('list-labourer-schedule')"
                        :link="{ name: 'Takeon Search', path: '/vendors/labourer-takeon-search',icon: 'search'}"/>
        </sidebar-item>
        <sidebar-item v-if="roles.length" :link="{ name: 'Vendor', icon: 'supervisor_account' }">
          <sidebar-item v-if="can('list-vendor')" :link="{ name: 'Vendors', path: '/vendors/list-vendors'}"/>
          <sidebar-item v-if="can('list-institution')"
                        :link="{  name: 'Institutions', path: '/employer/list-institutions'}"/>
        </sidebar-item>
        <sidebar-item :link="{ name: 'User Management', icon:'apps' }">
          <sidebar-item v-if="can('list-staff')" :link="{ name: 'Staff',path: '/employer/list-staffs'}"/>
          <sidebar-item v-if="can('list-user')"
                        :link="{name: 'User Management', path: '/clms/user-management/list-users'}"></sidebar-item>
          <sidebar-item v-if="can('list-role')"
                        :link="{name: 'Role Management', path: '/clms/role-management/list-roles'}"></sidebar-item>
          <sidebar-item v-if="can('list-permission')"
                        :link="{ name: 'Permissions Management', path: '/setting/list-permissions' }"></sidebar-item>
          <sidebar-item v-if="can('list-signature')"
                        :link="{name: 'Signature List',
                                  path: '/settings/signatures/list-signatures' }"></sidebar-item>
        </sidebar-item>
        <div class="logo">
          <a class="simple-text logo-mini" href="#" target="_parent">
            <div style="padding: 4px 0px;"> MD</div>
          </a>
          <a class="simple-text logo-normal" href="#" target="_parent">MASTER DATA</a>
        </div>
        <sidebar-item v-if="roles.length" :link="{ name: 'Guidance Config', icon:'apps' }">
          <sidebar-item v-if="can('list-status-option')"
                        :link="{ name: 'Status Options', path: '/settings/status/options/list' }"></sidebar-item>
          <sidebar-item v-if="can('list-workplace')"
                        :link="{name: 'Workplace', path: '/settings/setting/list-workplaces'}"></sidebar-item>
          <sidebar-item v-if="can('list-shift')"
                        :link="{name: 'Shifts', path: '/settings/setting/list-shifts' }"></sidebar-item>
          <sidebar-item v-if="can('list-activity')"
                        :link="{name: 'Activity',path: '/settings/list-activities'}"></sidebar-item>
          <sidebar-item v-if="can('list-activity')"
                        :link="{name: 'Activity Category', path: '/clms/category-management/list-categories' }">
          </sidebar-item>
          <sidebar-item v-if="can('list-vessel')"
                        :link="{name: 'Vessels Management', path: '/settings/list-vessels' }"></sidebar-item>
          <sidebar-item v-if="can('list-holiday')"
                        :link="{name: 'Holidays List', path: '/settings/list-holidays' }"></sidebar-item>
          <sidebar-item v-if="can('list-activity')"
                        :link="{ name: 'Contributions', path: '/finance/contribution/lists' }"/>
        </sidebar-item>

        <sidebar-item v-if="roles.length" :link="{ name: 'Labourer Config', icon:'apps' }">
          <sidebar-item v-if="can('list-religion')"
                        :link="{name: 'Religion', path: '/settings/list-religions' }"></sidebar-item>

          <sidebar-item v-if="can('list-skill-category')"
                        :link="{ name: 'Skills Categories', path: '/settings/list-skills-categories' }"></sidebar-item>

          <sidebar-item v-if="can('list-skill')"
                        :link="{ name: 'Skills', path: '/settings/list-skills' }"></sidebar-item>
          <sidebar-item v-if="can('list-level')"
                        :link="{ name: 'Levels', path: '/settings/list-levels' }"></sidebar-item>
          <sidebar-item v-if="can('list-attachment-type')"
                        :link="{ name: 'Attachment Types', path: '/settings/list-attachment-types' }"></sidebar-item>


          <sidebar-item
              :link="{ name: 'Guidance Categories', path: '/settings/list-guidance-categories' }"></sidebar-item>
        </sidebar-item>
        <!--                v-if="can('list-skills-category')"-->

        <sidebar-item :link="{ name: 'Location', icon:'map' }">
          <sidebar-item v-if="can('list-zone')"
                        :link="{name: 'Zones',path: '/settings/list-zones'}"></sidebar-item>
          <sidebar-item v-if="can('list-region')"
                        :link="{name: 'Regions',path: '/settings/list-regions'}"></sidebar-item>
          <sidebar-item v-if="can('list-district-type')"
                        :link="{name: 'District Types',path: '/settings/list-district-types' }"></sidebar-item>
          <sidebar-item v-if="can('list-district')"
                        :link="{name: 'Districts',path: '/settings/list-districts'}"></sidebar-item>
          <sidebar-item v-if="can('list-ward')"
                        :link="{name: 'Wards',path: '/settings/list-wards'}"></sidebar-item>
          <sidebar-item v-if="can('list-village')"
                        :link="{name: 'villages',path: '/settings/list-villages'}"></sidebar-item>
          <sidebar-item v-if="can('list-neighborhood')"
                        :link="{name: 'Neighborhoods',path: '/settings/list-neighborhoods'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{ name: 'Stations', icon:'home' }">
          <sidebar-item v-if="can('list-station')"
                        :link="{ name: 'Station', path: '/settings/setting/list-stations'}"></sidebar-item>
          <sidebar-item v-if="can('list-department')"
                        :link="{name: 'Department',path: '/settings/setting/list-departments'}"></sidebar-item>
          <sidebar-item v-if="can('list-port')"
                        :link="{name: 'Port', path: '/settings/setting/list-ports' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{ name: 'Biotimes', icon:'fingerprint' }">
          <sidebar-item v-if="can('list-station')"
                        :link="{ name: 'Transactions', path: '/biotime/attendance'}"></sidebar-item>
          <sidebar-item v-if="can('list-station')"
                        :link="{ name: 'Device', path: '/biotime/device'}"></sidebar-item>
          <sidebar-item v-if="can('list-department')"
                        :link="{name: 'Department',path: '/biotime/department'}"></sidebar-item>
          <sidebar-item v-if="can('list-port')"
                        :link="{name: 'Area', path: '/biotime/area' }"></sidebar-item>
          <sidebar-item v-if="can('list-port')"
                        :link="{name: 'Sync', path: '/biotime/sync' }"></sidebar-item>
          <sidebar-item v-if="can('list-port')"
                        :link="{name: 'Biometric Whitelist', path: '/biotime/whitelist/list' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{ name: 'Systems', icon:'clock' }">
          <sidebar-item v-if="can('list-station')"
                        :link="{ name: 'System', path: '/settings/clients/list'}"></sidebar-item>
          <sidebar-item v-if="can('list-sms-log')"
                        :link="{ name: 'Sms Logs', path: '/settings/sms/logs'}"></sidebar-item>
          <sidebar-item v-if="can('list-sms-log')"
                        :link="{ name: 'Settings Schedule', path: '/settings/schedule'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="roles.length" :link="{ name: 'Configurations', icon: 'settings' }">
          <sidebar-item v-if="can('list-category') && roles.includes('admin') || roles.includes('creator')"
                        :link="{name: 'Activity Category', path: '/clms/category-management/list-categories' }"></sidebar-item>
          <sidebar-item v-if="can('list-tag') && roles.includes('admin') || roles.includes('creator')"
                        :link="{name: 'Tag Management',path: '/clms/tag-management/list-tags'}"></sidebar-item>
          <sidebar-item v-if="can('list-item')"
                        :link="{name: 'Item Management', path: '/clms/item-management/list-items' }"></sidebar-item>
        </sidebar-item>

        <sidebar-item v-if="can('list-setting')"
                      :link="{name: 'System Setting', path: '/clms/category-management/list-categories' }"></sidebar-item>

      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <div
          :class="{ content: !$route.meta.hideContent }"
          @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view/>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import TopNavbar from './TopNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import MobileMenu from './Extra/MobileMenu.vue';
import UserMenu from './Extra/UserMenu.vue';
import Vuex from 'vuex';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith('Win');
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar('sidebar');
    initScrollbar('sidebar-wrapper');
    initScrollbar('main-panel');

    docClasses.add('perfect-scrollbar-on');
  } else {
    docClasses.add('perfect-scrollbar-off');
  }
}

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    UserMenu
  },
  data() {
    return {
      sidebarBackgroundColor: 'black',
      sidebarBackground: 'green',
      sidebarBackgroundImage: process.env.VUE_APP_BASE_URL + '/img/sidebar-2.jpg',
      sidebarMini: false,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + '/img/laravel-vue.svg',
      roles: [],
      allPermissions: []
    };
  },
  created() {
    this.loadNotificationCount();

    this.notificationInterval = setInterval(() => {
      this.loadNotificationCount();
    }, 300000);//5 min
  },
  beforeDestroy() {
    clearInterval(this.notificationInterval);
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },

    loadNotificationCount() {
      this.$store.dispatch('notifications/count');
    }
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  computed: {
    ...Vuex.mapState({
      me: state => state.profile.me
    }),
    notificationCount() {
      return this.$store.getters['notifications/count'];
    },
    notifications() {
      return this.$store.getters['notifications/items'] || [];
    }
  },
  watch: {
    me: {
      handler: function (val) {
        if (val !== null) {
          this.roles = val.roles.map(r => r.name);
          this.allPermissions = val.allPermissions.map(p => p.name);
        }
      },
      deep: true,
      immediate: true,
    },
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>

